import { render, staticRenderFns } from "./serveThree.vue?vue&type=template&id=37353a66&scoped=true&"
import script from "./serveThree.vue?vue&type=script&lang=js&"
export * from "./serveThree.vue?vue&type=script&lang=js&"
import style0 from "./serveThree.vue?vue&type=style&index=0&id=37353a66&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37353a66",
  null
  
)

export default component.exports